window.handleTickInit = function(tick) {
  if (!window.RAILS_ENV) {
    window.RAILS_ENV = 'production'; // 念のためデフォルト
  }

  function devLog(...args) {
    if (window.RAILS_ENV === 'development') {
      console.log(...args);
    }
  }

  function devError(...args) {
    if (window.RAILS_ENV === 'development') {
      console.error(...args);
    }
  }

  devLog('[love_countdown] handleTickInit：開始')

  const countdownElement = document.getElementById('js-loveCountdown');
  const contentElement = document.getElementById('js-loveCountdownPublicContent');

  if (!countdownElement) {
    devLog('[love_countdown] カウントダウン不要やから、Tick起動せえへんで〜');
    return;
  }

  var locale = {
    YEAR_PLURAL: '年',
    YEAR_SINGULAR: '年',
    MONTH_PLURAL: '月',
    MONTH_SINGULAR: '月',
    WEEK_PLURAL: '週',
    WEEK_SINGULAR: '週',
    DAY_PLURAL: '天',
    DAY_SINGULAR: '天',
    HOUR_PLURAL: '小時',
    HOUR_SINGULAR: '小時',
    MINUTE_PLURAL: '分鐘',
    MINUTE_SINGULAR: '分鐘',
    SECOND_PLURAL: '秒',
    SECOND_SINGULAR: '秒',
    MILLISECOND_PLURAL: '毫秒',
    MILLISECOND_SINGULAR: '毫秒'
  };

  for (var key in locale) {
    if (!locale.hasOwnProperty(key)) continue;
    tick.setConstant(key, locale[key]);
  }

  if (!countdownElement || !contentElement) {
    devError('[love_countdown] 必要な要素が見つかりません')
    return
  }

  fetch('/love_countdown_target_time', {
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(data => {
    devLog('[love_countdown] ターゲットデータ受信', data)
    const serverNow = new Date(data.now_time)
    const targetDate = new Date(data.target_time)

    startCountdown(tick, serverNow, targetDate)
  })
  .catch(error => {
    devError('[love_countdown] ターゲット取得失敗', error)
  })

  function startCountdown(tick, serverNow, targetDate) {
    devLog('[love_countdown] カウントダウンスタート')

    const diffMs = targetDate - serverNow
    const endDate = new Date(Date.now() + diffMs)

    const counter = Tick.count.down(endDate, { format: ['d', 'h', 'm', 's'] })

    counter.onupdate = (value) => {
      tick.value = value

      if (value.days === 0 && value.hours === 0 && value.minutes === 0 && value.seconds === 0) {
        devLog('[love_countdown] カウント0！公開チェックへ')
        checkPublish()
      }
    }

    counter.onended = () => {
      devLog('[love_countdown] カウントダウン終了（onended）')
      checkPublish()
    }
  }

  function checkPublish() {
    devLog('[love_countdown] 公開チェック開始')

    fetch('/love_countdown_public_contents', {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      devLog('[love_countdown] 公開判定受信', data)

      if (data.published) {
        devLog('[love_countdown] 公開OK！カウントダウンを非表示')
        countdownElement.style.display = 'none'
        contentElement.style.display = 'block'
        contentElement.innerHTML = data.content_html
      } else {
        devLog('[love_countdown] まだ公開されてない')
      }
    })
    .catch(error => {
      devError('[love_countdown] 公開チェック失敗', error)
    })
  }
}
